const redux = require('redux'),
    ReduxThunk = require('redux-thunk').default;

const finalCreateStore = redux.compose(
    redux.applyMiddleware(ReduxThunk),
    typeof window === 'object' && typeof window.devToolsExtension !== 'undefined' ? window.devToolsExtension() : (f) => f
)(redux.createStore);

export const configureStore = function(initialState, rootReducer) {
    const store = finalCreateStore(rootReducer, initialState);

    return store;
};


// WEBPACK FOOTER //
// ./src/config/index.js